import React from "react";
import * as Mui from "@mui/material";
import { validate } from "shared/yup";
import * as yup from "yup";
import { Integration } from "model/integration";
import { SimpleIntegrationModal } from "../../simple-integration-modal";

export const validationSchema = {
	url: yup.string()
		.required("Webhook URL is required")
		// The server refuses to deliver to a non-HTTPS URL, so don't let one be saved.
		.matches(/^https:\/\//i, "Webhook URL must start with https://"),
	secret: yup.string().required("Signing secret is required"),
};

interface Props {
	open: boolean;
	onClose: () => void;
	integration: Integration;
	name?: string;
	url?: string;
	secret?: string;
	includeAnonymous: boolean;
	showValidation: boolean;
	onNameChange: (name: string) => void;
	onUrlChange: (url: string) => void;
	onSecretChange: (secret: string) => void;
	onIncludeAnonymousChange: (includeAnonymous: boolean) => void;
	onSave: () => void;
}

export class ClientEventWebhookModal extends React.Component<Props> {

	public render() {
		const {
			open, onClose, integration, name, url, secret, includeAnonymous, showValidation,
			onNameChange, onUrlChange, onSecretChange, onIncludeAnonymousChange, onSave,
		} = this.props;
		const errors = validate(validationSchema, { url, secret });

		return (
			<SimpleIntegrationModal open={open} onClose={onClose} integration={integration}>
				<Mui.Grid container direction="column" spacing={2}>
					<Mui.Grid item>
						<Mui.TextField
							label="Name" placeholder={integration.integrationType.name}
							value={name || ""} onChange={e => onNameChange(e.target.value)}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.TextField
							label="Webhook URL" placeholder="https://"
							value={url || ""} onChange={e => onUrlChange(e.target.value)}
							helperText={showValidation && errors && errors.url}
							error={showValidation && errors && !!errors.url}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.TextField
							label="Signing Secret"
							value={secret || ""} onChange={e => onSecretChange(e.target.value)}
							helperText={
								(showValidation && errors && errors.secret)
								|| "Signs every delivery (HMAC-SHA256, X-IHF-Signature header) so your endpoint can verify it came from us."
							}
							error={showValidation && errors && !!errors.secret}
							fullWidth margin="dense" variant="outlined"
						/>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.FormControlLabel
							control={
								<Mui.Switch
									checked={includeAnonymous}
									onChange={e => onIncludeAnonymousChange(e.target.checked)}
									color="primary"
								/>
							}
							label="Include anonymous activity"
						/>
						<Mui.Typography variant="body2" color="textSecondary">
							Also deliver listing views and searches from visitors who have not registered. Anonymous listing views are the highest-volume events on the platform.
						</Mui.Typography>
					</Mui.Grid>
					<Mui.Grid item>
						<Mui.Button variant="contained" color="primary" onClick={onSave}>Save</Mui.Button>
					</Mui.Grid>
				</Mui.Grid>
			</SimpleIntegrationModal>
		);
	}

}
